import { render, staticRenderFns } from "./EditPermiso.vue?vue&type=template&id=74f51f18&"
import script from "./EditPermiso.vue?vue&type=script&lang=js&"
export * from "./EditPermiso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports